var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// FIXME: move to different file?
import { List } from "immutable";
//const DataClasses = require('./data_classes.ts');
import { airspeedMetersPerSecond } from "./data_classes.js";
// store separately to reduce object size
export let airfoilTestsByAirfoilId = new Map();
export class SearchConstraints {
    dynamicPressure(airspeedKmh) {
        const airspeedMetersPerSecond_ = airspeedMetersPerSecond(airspeedKmh);
        return 0.5 * this.env.airDensity * airspeedMetersPerSecond_ * airspeedMetersPerSecond_;
    }
    chordLengthMetersFromReynolds(airspeedMetersPerSecond, airfoilRe) {
        // https://en.wikipedia.org/wiki/Reynolds_number
        // ρ is the density of the fluid (SI units: kg/m3)
        // u is the flow speed (m/s)
        // L is a characteristic length (m)
        // ν is the kinematic viscosity of the fluid (m2/s).
        // if using kinematic viscosity:
        // Reynolds = velocity * L / kinematic_viscocity
        return airfoilRe * this.env.kinematicViscosity / airspeedMetersPerSecond;
    }
    speedMetersPerSecFromReynolds(chordMeters, airfoilRe) {
        // https://en.wikipedia.org/wiki/Reynolds_number
        // ρ is the density of the fluid (SI units: kg/m3)
        // u is the flow speed (m/s)
        // L is a characteristic length (m)
        // ν is the kinematic viscosity of the fluid (m2/s).
        // if using kinematic viscosity:
        // Reynolds = velocity * L / kinematic_viscocity
        return airfoilRe * this.env.kinematicViscosity / chordMeters;
    }
    findMaxDistanceParams() {
        const results = [];
        const weightNewtons = this.weightKg * 9.81; // FIXME: use gravity from env
        let airfoilsScanned = 0; // FIXME
        // prefilter airfoils on planeTypes support
        GenericSimulatedAirfoil.findRelevantAirfoils(this.planeTypes)
            .forEach((airfoil) => {
            if (this.enabledAirfoilNames.indexOf(airfoil.airfoilName) == -1) {
                console.log("skipping airfoil: ", airfoil.airfoilName);
            }
            else {
                const airfoilTests = airfoilTestsByAirfoilId.get(airfoil.airfoilName) || [];
                airfoilTests.forEach((xfoilTest) => {
                    const AirfoilCm0 = airfoil.cm0; // FIXME: should be zero lift or zero angle?
                    const maxLdRow = xfoilTest.maxLdRow;
                    const AirfoilMaxLd = maxLdRow.Cl / maxLdRow.Cd;
                    // make it always use maxLD alpha point
                    // speed unknown
                    // liftNewtons = weightKg<fixed> = CL<fixed> * (0.5 * this.airDensity<fixed> * speed^2) * chord[via speed] * aspect [variable] * chord (!);
                    // so enough just to iterate all chord lenghts, calc speeds from Re, and aspect from Lift formula
                    // Reynolds [fixed] = velocity * chord / kinematic_viscocity
                    for (let chordMeters = this.chordMeters.min; chordMeters <= this.chordMeters.max; chordMeters += this.chordMeters.increment) {
                        airfoilsScanned++;
                        const Re = xfoilTest.Re;
                        const airspeedMeterPerSec = this.speedMetersPerSecFromReynolds(chordMeters, Re);
                        const airspeedKmh = airspeedMeterPerSec * 3.6;
                        if (airspeedKmh >= this.speedKmh.min && airspeedKmh <= this.speedKmh.max) {
                            if (chordMeters < 0.01) {
                                // prevent division by zero and meaningless computations
                                continue;
                            }
                            // FIXME: pass a row instead!
                            this.maybeAddResult(airspeedKmh, weightNewtons, maxLdRow.Cl, chordMeters, maxLdRow, airfoil, results, xfoilTest, maxLdRow.Cd, maxLdRow.Cm, Re, AirfoilCm0, AirfoilMaxLd);
                        }
                    }
                    if (!this.checkOnlyMaxLDAlpha) {
                        xfoilTest.xfoilTest.data.forEach((xfoilRow) => {
                            // FIXME: assumption - is it always most efficient to fly at airfoil LD? NO! because CDi=CL^2/aspect... might shift the maxLD point?
                            // FIXME: soooo we need to take into account CDi from the start!!!
                            // FIXME 2. prefilter on Re if chord constraint supports it (?)
                            // FIXME: find new max L/D spot with CDi taken into account!
                            // not using ONLY maxLD for now, at least until we have more foils
                            // const xfoilRow = xfoilTest.maxLdRow;
                            const AirfoilCl = xfoilRow.Cl;
                            const AirfoilCd = xfoilRow.Cd;
                            const AirfoilCm = xfoilRow.Cm;
                            const Re = xfoilTest.Re;
                            for (let airspeedKmh = this.speedKmh.min; airspeedKmh <= this.speedKmh.max; airspeedKmh += this.speedKmh.increment) {
                                airfoilsScanned++;
                                const airspeedMeterPerSec = airspeedMetersPerSecond(airspeedKmh);
                                const chordMeters = this.chordLengthMetersFromReynolds(airspeedMeterPerSec, Re);
                                if (chordMeters < 0.01) {
                                    // prevent division by zero and meaningless computations
                                    continue;
                                }
                                this.maybeAddResult(airspeedKmh, weightNewtons, AirfoilCl, chordMeters, xfoilRow, airfoil, results, xfoilTest, AirfoilCd, AirfoilCm, Re, AirfoilCm0, AirfoilMaxLd);
                            }
                            // such that weight == lift
                            // eq1. liftNewtons = weightKg<fixed> = CL<fixed> * (0.5 * this.airDensity<fixed> * speed^2) * chord[via speed] * aspect [variable];
                            // eq2. xfoil.Re // hmmm this implies Re=speed * chord * const
                            //   eq2.2   ==>  chord=Re/speed / const
                            // so ONLY one of aspect or chord is free variable, and dictated by weight
                            // FIXME: hmm so might be Re is exactly same, or lift is not exactly same, because Re is a second constraint on speed AND chord,
                            //  or aspect is locked otherwise if we want to match exactly the test result
                        });
                    }
                });
            }
        });
        return {
            results,
            variantsScanned: airfoilsScanned
        };
    }
    maybeAddResult(airspeedKmh, weightNewtons, AirfoilCl, chordMeters, xfoilRow, airfoil, results, xfoilTest, AirfoilCd, AirfoilCm, Re, AirfoilCm0, AirfoilMaxLd) {
        const dynamicPressure = this.dynamicPressure(airspeedKmh);
        // liftNewtons = weightKg<fixed> = CL<fixed> * (0.5 * this.airDensity<fixed> * speed^2) * chord[via speed] * aspect [variable] * chord (!);
        const aspectRatio = weightNewtons / (
        // FIXME: not sure if we want maxLD of the airfoil, or maxLD of the plane with Cdi taken into account
        // so that lift would match to weight
        AirfoilCl * dynamicPressure * chordMeters * chordMeters);
        const LD = xfoilRow.Cl / xfoilRow.Cd;
        const alpha = xfoilRow.Alpha;
        const nameHtml = airfoil.airfoilName.replace("xf-", "").replace("-il", "");
        const airfoilLink = airfoil.airfoilLink();
        const airfoilDescription = airfoil.airfoilDescription;
        const tldr = airfoil.tldr;
        const imageLinks = airfoil.imageLinks;
        const linksHtml = airfoil.linksHtml;
        if (aspectRatio <= this.aspect.max && aspectRatio >= this.aspect.min &&
            chordMeters <= this.chordMeters.max && chordMeters >= this.chordMeters.min
        //Re <= this.Re.max && Re >= this.Re.min
        ) {
            results.push({
                airfoil,
                xfoilTest,
                airspeedKmh,
                maxLdChord: chordMeters,
                maxLdAspect: aspectRatio,
                AirfoilCl,
                AirfoilCd,
                AirfoilCm,
                dynamicPressure,
                Re,
                Ld: LD,
                nameHtml,
                airfoilLink,
                Alpha: alpha,
                airfoilDescription,
                AirfoilCm0,
                AirfoilMaxLd,
                tldr,
                imageLinks,
                linksHtml,
                airfoilType: 'xfoil'
            });
        }
    }
    constructor(checkOnlyMaxLDAlpha, enabledAirfoilNames, env, planeTypes, weightKg, speed, chord, aspect, Re) {
        this.checkOnlyMaxLDAlpha = checkOnlyMaxLDAlpha;
        this.enabledAirfoilNames = enabledAirfoilNames;
        this.env = env;
        this.planeTypes = planeTypes;
        this.weightKg = weightKg;
        this.aspect = aspect;
        this.chordMeters = chord;
        this.speedKmh = speed;
        this.Re = Re;
    }
}
export class GenericSimulatedAirfoilTest {
    // FIXME: if Re don't match accurately (or ensure it matches - iterate from the other way round!),
    //  this will return quite a mess, we quite really need interpolation?
    //public getClCdAlpha(requestedCL) {
    // XfoilRow:
    //     Alpha: number,
    //     Cl: number,
    //     Cd: number,
    //     Cdp: number,
    //     Cm: number,
    //     Top_Xtr: number,
    //     Bot_Xtr: number,
    //}
    constructor(xfoilTest) {
        this.xfoilTest = xfoilTest;
        const maxLdAlpha = xfoilTest["Max Cl/Cd alpha"];
        this.maxLdRow = List(xfoilTest.data.filter((x) => x.Alpha == maxLdAlpha)).first();
        this.Re = xfoilTest["Reynolds number"];
        this.maxLdAlpha = maxLdAlpha;
        this.maxLd = xfoilTest["Max Cl/Cd"];
    }
}
export class GenericSimulatedAirfoil {
    constructor(cm0, airfoilName, airfoilDescription, tests, link, 
    // these are tied to each individual test condition actually
    minRe, airfoil
    // supportPlank: boolean = false, // cm c/4  >= 0.0050
    // // CmMin: number|undefined = undefined,
    // // CmMax: number|undefined = undefined,
    // // CmApprox: number|undefined = undefined,
    // supportSweptWing: boolean = false, // cm c/4 ~= 0.0050
    // supportTail: boolean = true, // cm c/4  >=0
    ) {
        this.cm0 = cm0;
        this.airfoilName = airfoilName;
        this.airfoilDescription = airfoilDescription;
        airfoilTestsByAirfoilId.set(airfoilName, List(tests).map((t) => new GenericSimulatedAirfoilTest(t)).toArray());
        this.minRe = minRe;
        this.supportAerobatics = airfoil.supportAerobatics;
        this.supportPlankDS = airfoil.supportPlankDS;
        this.supportPlank = airfoil.supportPlank;
        this.supportTail = airfoil.supportTail;
        this.supportSweptWing = airfoil.supportSweptWing;
        this.tldr = airfoil.tldr;
        this.imageLinks = airfoil.imageLinks;
        this.linksHtml = airfoil.links.map((l) => `<a href="${l}" target="_blank">${l}</a>`);
        if (airfoilName.startsWith("xf-")) {
            this.linksHtml.push(`<a href="${this.link}" target="_blank">airfoiltools: airfoil drawing and DAT file</a>`);
            this.link = link;
        }
        else {
            this.link = undefined;
        }
    }
    // CmMin: number|undefined;
    // CmMax: number|undefined;
    // CmApprox: number|undefined;
    // public findClosestTestByRe(Re: number): GenericSimulatedAirfoilTest[] {
    //     if (Re < this.minRe){
    //         return [];
    //     }
    //     // FIXME: if there are two foils of same Re difference should choose one with lower Re (?), or interpolate
    //     // FIXME: maybe find two closest and interpolate in between
    //     const bestTest: ReDifference = List(this.tests).map((t: GenericSimulatedAirfoilTest) => {
    //             const a: ReDifference = {
    //                 diff: Math.abs(t.Re-Re),
    //                 t: t};
    //             return a;
    //         }
    //     ).sortBy((dict: ReDifference) => dict.diff)
    //         .first()
    //     return [bestTest.t];
    // }
    static findRelevantAirfoils(planeType) {
        console.log("findRelevantAirfoils, XfoilFoils.length: ", XfoilFoils.length);
        // FIXME: this might be not very efficient if there's many airfoils, as we iterate over many Re's,
        //  and .flatMap copies data
        return (List(XfoilFoils));
        //.filter((f: GenericSimulatedAirfoil) => f.supportsPlanTypes(planeType)));
        // FIXME: this filter makes no sense if I iterate from the other way round:
        // airfoil -> test -> alpha,cl,cd => Re+CL (span+aspect, speed)
        // FIXME: can we assume for now that we are ONLY interested into exactly matching the maxLD spot of the test, so it'd be much simpler & efficient
        // .flatMap((f: GenericSimulatedAirfoil) => f.findClosestTestByRe(Re));
    }
    supportsPlanTypes(requestedPlaneTypes) {
        return (requestedPlaneTypes.supportPlank && this.supportPlank) ||
            (requestedPlaneTypes.supportTail && this.supportTail) ||
            (requestedPlaneTypes.supportSweptWing && this.supportSweptWing) ||
            (requestedPlaneTypes.supportAerobatics && this.supportAerobatics) ||
            (requestedPlaneTypes.supportPlankDS && this.supportPlankDS);
    }
    airfoilLink() {
        return this.link;
    }
    static createFoils(foils) {
        return foils
            //.filter((foil: AirfoilTests) => foil.airfoil.includes("-pw"))
            .map((foil) => {
            // FIXME: this is not valid if airfoil not uploaded!
            const url = `http://airfoiltools.com/airfoil/details?airfoil=${foil.airfoil.replace("xf-", "")}#polars`;
            return new GenericSimulatedAirfoil(foil.cm0, foil.airfoil, foil.descr, foil.tests, url, foil.minRe, foil // cm c/4  >=0
            );
        });
    }
}
// TODO: add more foils here
export const XfoilFoils = [];
// Function to load JSON data from a URL
export function loadJsonFromUrl(url) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    });
}
